import { ExpressionValidationResultDc } from "@evergis/api";
import { Icon, Tooltip } from "@evergis/ui";
import { Flex } from "grid-styled";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

export interface ServerValidationErrorProps {
  error: ExpressionValidationResultDc;
}

export const ServerValidationError: FC<ServerValidationErrorProps> = ({ error }) => {
  const { t } = useTranslation("common");

  return (
    <Flex alignItems={"center"}>
      <Icon kind={"warning"} error />
      <Tooltip
        content={
          <>
            {error.errors.map(errorString => (
              <p>{errorString}</p>
            ))}
          </>
        }
        arrow
        placement={"top"}
      >
        {ref => <div ref={ref}>{t("expressionValidationError")}</div>}
      </Tooltip>
    </Flex>
  );
};
